<script lang="ts">
    import Icon from './icons.svelte';
    import type {IconTypes} from './icons.svelte';

    export let handleClick = () => {}
    export let label:string = '';
    export let ariaLabel:string = '';
    export let role:buttonRole = 'primary';
    export let icon:IconTypes = 'none';
    export let disabled:boolean = false;
    export let buttonGroup:boolean = false;
    export let roundedCorners:boolean = true;
    export let iconLeft:boolean = false;

    type buttonRole = 'primary' | 'secondary' | 'tertiary' | 'destructive';

    if (ariaLabel === '') {
        ariaLabel = label;
    }

    let className = 'primary';
    if (role === 'secondary') {
        className = 'secondary';
    } else if (role === 'tertiary') {
        className = 'tertiary';
    } else if (role === 'destructive') {
        className = 'destructive';
    }
</script>

<button 
    on:click={handleClick}
    class={className}
    {disabled}
    class:notRounded={!roundedCorners}
    class:has-icon-right="{icon !== 'none' && label !== ''}"
    class:has-icon-left="{icon !== 'none' && label !== '' && iconLeft}"
    class:in-button-group="{buttonGroup}"
    aria-label={ariaLabel}
>
        {#if icon && iconLeft}
            <Icon icon={icon} color="text" {disabled} />
        {/if}
        <span class="label-text">{label}</span>
        {#if icon && !iconLeft}
            <Icon icon={icon} color="text" {disabled} />
        {/if}
</button>

<style>
    button {
        padding: 16px 24px;
        color: var(--text);
        background: var(--background);
        box-sizing: border-box;
        border-radius: 8px;
        font-weight: bold;
        font-size: 16px;
        line-height: 16px !important;
        /* height: 48px; */
        display: inline-flex;
        margin: 0;
    }
    .in-button-group:not(:last-child) {
        margin: 0 8px 8px 0;
    }

    button.has-icon-right > span {
        margin-right: 1rem; /* spacing between label text and icon if present */
    }
    button.has-icon-left > span {
        margin-left: 1rem; /* spacing between label text and icon if present */
    }
    span.label-text {
        line-height: 16px !important;
        display: inline-block;
        height: 16px;
    }
    button:disabled {
        cursor: not-allowed;
        
    }
    button.secondary:disabled {
        border-color: var(--text-disabled);
    }
    button:disabled:hover {
        background-color: unset;
        border-color: none;
    }
    button.primary {
        border: 4px solid var(--text);
        box-shadow: 0px 9px 11px rgba(0, 0, 0, 0.1), 0px 6px 0px rgba(0, 0, 0, 0.1);
    }
    button.secondary {
        padding: 18px 26px;
        border: 2px dotted var(--background-offset);
    }
    button.tertiary {
        border: none;
        padding: 20px;
        font-weight: normal;
    }
    button.tertiary:hover {
        border: none;
    }
    button.destructive {
        color: white;
        background: #aa162a;
        border: 4px solid #aa162a;
        box-shadow: 0px 9px 11px rgba(88, 11, 22, 0.1), 0px 6px 0px rgba(88, 11, 22, 0.1);
    }
    button.destructive:hover {
        background: #7a101e;
    }
    button:focus-visible {
        outline: 2px solid var(--text);
        animation: focus_color 0.6s ease-in-out 0s infinite alternate
    }
    button:hover {
        background-color: var(--background-offset);
    }
    .notRounded {
        border-radius: 0;
    }

    @keyframes focus_color{ from { outline-color: var(--text); } to { outline-color: var(--background-offset); }  }
</style>